import { sanitizePhoneInput } from "./phone-input-value";

/**
 * Ensures a phone string is E.164-prefixed (starts with "+").
 * Strips whitespace and non-digit characters, avoiding double-"+".
 */
export function normalizePhone(raw: string): string {
  const sanitized = sanitizePhoneInput(raw.replace(/\s+/g, ""));
  const digits = sanitized.replace(/^\+/, "");
  return digits ? `+${digits}` : "";
}
